// extracted by mini-css-extract-plugin
module.exports = {"connectionsPlot":"DrawConnections_connectionsPlot__2eJAg"};